import React, { Component, useEffect } from "react"
import { StaticQuery, graphql } from "gatsby"
import GlobalHeaderWrapper from "./globalHeaderWrapper"
import PropTypes from "prop-types"
import Icon from "../../components/icon-v2"
import Menu from "./Menu"
import SbEditable from "storyblok-react"
import Components from "../../components"
import linkHandler from "../../helpers/storyblokLinkHandler"
import PageNav from "./PageNav"
import Cookies from "js-cookie"
import { getKey } from "../../helpers/getKey"
import NotificationBar from "./NotificationBar"
import GlobalNotifications from "./GlobalNotifications"
import {
    StyledNotification,
    StyledNotificationDummy,
    StyledNotificationMessage,
    StyledNotificationText,
    StyledNotificationClose,
    StyledHeader,
    StyledHeaderInner,
    StyledLogo,
    StyledNav,
    StyledNavItem,
    StyledNavCta,
} from "./partials/StyledGlobalHeader"
import IconV2 from "../../components/icon-v2"

import {
    notificationClosed,
    closeNotification,
  } from "../../helpers/handleCookies"

class GlobalHeader extends Component {
    state = {
        displayMenu: false,
        displayNotice: true,
        isSticky: false,
    }
    componentDidMount() {
        var getHeaderHeight = this.headerRef.offsetHeight
        this.setState({
            headerHeight: getHeaderHeight,
        })
        if (window && typeof window !== "undefined") {
            window.addEventListener("scroll", () => {
                this.handleScroll()
            })
        }
        if (notificationClosed()){
            this.setState({
                displayNotice: false,
            })
        }
        else{
            this.setState({
                displayNotice: true,
            })
        }
    }
    handleScroll = () => {
        var getScrollValue = window.scrollY
        var getHeaderHeight = this.headerRef.offsetHeight
        if (getScrollValue > getHeaderHeight) {
            this.setState({
                isSticky: true,
            })
        } else if (getScrollValue < getHeaderHeight) {
            this.setState({
                isSticky: false,
            })
        }
    }
    hideNotice = () => {
        const { displayNotice } = this.state

        this.setState({
            displayNotice: false,
        })

        closeNotification()
    }
    toggleMenu = () => {
        const { displayMenu } = this.state

        this.setState({
            displayMenu: !displayMenu,
        })
        document.getElementsByTagName("body")[0].classList.toggle("g--no-scroll-v2")
    }
    render() {
        const { displayMenu } = this.state
        const { blok } = this.props
        const pageNavExists = blok.page_nav && blok.page_nav.length > 0 ? true : false

        return (
            <SbEditable content={blok}>
                {blok.notification_bar && (
                <GlobalNotifications notification_bar={blok.notification_bar} />
                )}
                {blok.side_nav && blok.side_nav.length > 0 && (
                    <Menu
                    data-name="menu"
                        pageNavExists={pageNavExists}
                        path={this.props.path}
                        isOpen={displayMenu}
                        logo={blok.side_logo ? blok.side_logo.filename : null}
                        nav={blok.side_nav}
                        onClickHandler={this.toggleMenu}
                        pageTitle={blok.page_nav_page_title}
                        pageNav={blok.page_nav}
                        pageButtons={blok.page_nav_buttons}
                        pageNavProgram={blok.page_nav_program}
                    />
                )}
                <StyledHeader
                data-name="navigation"
                    isSticky={this.state.isSticky}
                    id="site-header"
                    full_bleed={blok.full_bleed}
                    headerHeight={this.state.headerHeight}
                    fixHeight={this.props.fixHeight}
                    legacy={blok.legacy_container}
                    background={blok.background_color}
                >
                    <StyledHeaderInner
                        ref={(element) => (this.headerRef = element)}
                        legacy={blok.legacy_container}
                        full_bleed={blok.full_bleed}
                    >
                        <StyledLogo
                            full_bleed={blok.full_bleed}
                            background={blok.background_color}
                            href={linkHandler(blok.logo_url)}
                        >
                            {blok.logo && (
                                <img
                                    title={blok.logo.title}
                                    alt={blok.logo.alt}
                                    src={blok.logo.filename}
                                />
                            )}
                        </StyledLogo>
                        <StyledNav>
                            {blok.nav &&
                                blok.nav.map((content) => (
                                    <StyledNavItem
                                        background={blok.background_color}
                                        key={content._uid}
                                        mobileHide={true}
                                        href={linkHandler(content.link)}
                                        target={content.target || "_self"}
                                    >
                                        {content.label}
                                    </StyledNavItem>
                                ))}
                            {blok.side_nav && blok.side_nav.length > 0 && (
                                <StyledNavCta
                                    background={blok.background_color}
                                    onClick={this.toggleMenu}
                                >
                                    <p>Menu</p>
                                    <Icon icon="bars" iconType="fal" />
                                </StyledNavCta>
                            )}
                        </StyledNav>
                    </StyledHeaderInner>
                    {pageNavExists && (
                        <PageNav
                            pageNavExists={pageNavExists}
                            path={this.props.path}
                            onClickHandler={this.toggleMenu}
                            isSticky={this.state.isSticky}
                            shield={blok.page_nav_shield}
                            title={blok.page_nav_page_title}
                            nav={blok.page_nav}
                            buttons={blok.page_nav_buttons}
                            pageNavProgram={blok.page_nav_program}
                        />
                    )}
                </StyledHeader>
            </SbEditable>
        )
    }
}

GlobalHeader.defaultProps = {}

GlobalHeader.propTypes = {}

// export default this.props.path === "/hult/s22/config/navigation/s22-header/" ? GlobalHeader : GlobalHeaderWrapper(GlobalHeader) 
export default GlobalHeaderWrapper(GlobalHeader)
